// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"757":"e64f5c89","802":"6601712c","879":"91ab3a1a"}[chunkId] + ".chunk.js";
};